import type { IntervalUnit } from '../../../types';

type UnitSuffixStrings = {
    CHARGE_CYCLES: string;
    FLIGHT_HOURS: string;
    UNIT_FLIGHTS: string;
};

export const getUnitSuffix = ({
    strings,
    unit
}: {
    strings: UnitSuffixStrings;
    unit: IntervalUnit;
}): string => {
    const suffixes: Record<IntervalUnit, string> = {
        cycles: strings.CHARGE_CYCLES,
        flights: strings.UNIT_FLIGHTS,
        hours: strings.FLIGHT_HOURS
    };

    return suffixes[unit];
};
